import '../../styles/components/leyout/Footer.css';

const Footer = (props) => {
    return (

        <footer>   TECNO TOOLS Copyright &copy; - 2024  </footer> 
        
    );
}
export default Footer;